import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BannedGroup } from '../../models/new-release-page.types';

@Component({
  selector: 'pla-new-release-banned-group',
  templateUrl: './new-release-banned-group.component.html',
  styleUrls: ['./new-release-banned-group.component.scss'],
})
export class NewReleaseBannedGroupComponent {
  @Input() group!: BannedGroup;

  constructor(private router: Router) {}

  get remainder(): number {
    return Math.max(0, this.group.count - this.group.samplePlates.length);
  }

  get countLabel(): string {
    return `${this.group.count} plate${this.group.count === 1 ? '' : 's'}`;
  }

  onPillClick(plate: string): void {
    const reg = (plate || '').replace(/\s+/g, '');
    if (!reg) return;
    this.router.navigate(['/plate', reg]);
  }
}
